import { styled, keyframes } from '@clickcease/cc-client-components-lib'
import * as DialogPrimitive from '@radix-ui/react-dialog'

const overlayShow = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 0.7 },
})

const contentShow = keyframes({
  '0%': { opacity: 0, transform: 'translate(-50%, -48%) scale(.96)' },
  '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
})

export const StyledOverlay = styled(DialogPrimitive.Overlay, {
  backgroundColor: '$textColor',
  opacity: 0.7,
  position: 'fixed',
  inset: 0,
  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${overlayShow()} 500ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
})

export const TriggerButton = styled(DialogPrimitive.Trigger, {
  all: 'unset',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '5px',
  padding: '0 15px',
  fontSize: '$lg',
  lineHeight: 1,
  fontWeight: 500,
  height: '35px',
  border: '1px solid rgb(28, 28, 31)',
  backgroundColor: 'white',
  color: '#161618',
  cursor: 'pointer',

  '&:hover': { backgroundColor: 'rgb(237, 237, 239)' },
})

export const StyledContent = styled(DialogPrimitive.Content, {
  backgroundColor: 'white',
  boxShadow: 'hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px',
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${contentShow()} 150ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
  '&:focus': { outline: 'none' },

  variants: {
    borderRadius: {
      '12px': {
        borderRadius: '12px',
      },
      '25px': {
        borderRadius: '25px',
      },
      '4px': {
        borderRadius: '4px',
      },
    },
  },
  defaultVariants: {
    borderRadius: '25px',
  },
})

export const StyledCloseButton = styled(DialogPrimitive.Close, {
  all: 'unset',
  position: 'absolute',
  top: '10px',
  right: '10px',
  padding: '10px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  borderRadius: '50%',
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
})
